import { render, staticRenderFns } from "./ColorTest.vue?vue&type=template&id=001fa751&scoped=true&"
import script from "./ColorTest.vue?vue&type=script&lang=js&"
export * from "./ColorTest.vue?vue&type=script&lang=js&"
import style0 from "./ColorTest.vue?vue&type=style&index=0&id=001fa751&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001fa751",
  null
  
)

export default component.exports